{
  "COMMON": {
    "LOADING": "Chargement en cours...",
    "ERROR_CODE": {
      "ALXXX": "Nous ne pouvons malheureusement pas récupérer d'autres options de vol pour le moment. Veuillez choisir une autre option ou réessayer plus tard. Vous pouvez également contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "COXXX_1": "Nous ne pouvons malheureusement pas traiter votre réservation pour le moment. Veuillez réessayer plus tard. [Code d'erreur : {{errorCode}}]",
      "COXXX_2": "Nous ne pouvons malheureusement pas identifier votre réservation pour le moment. Nous vous invitons à réessayer ultérieurement ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "DIXXX": "Nous ne pouvons malheureusement pas traiter votre demande pour le moment. Nous vous invitons à réessayer ultérieurement ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "EMXXX": "L'e-mail n'a malheureusement pas pu être envoyé. Veuillez réessayer plus tard. [Code d'erreur : {{errorCode}}]",
      "EXXXX": "Nous ne pouvons malheureusement pas traiter votre demande pour le moment. Nous vous invitons à réessayer ultérieurement ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "EX115": "Nous ne pouvons malheureusement pas traiter votre demande pour le moment. Nous vous invitons à réessayer dans 15 minutes ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire</a>. [Code d'erreur : {{errorCode}}]",
      "EX197": "Malheureusement, un problème est survenu lors de votre remboursement. Nous vous invitons à réessayer ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire</a>.",
      "EX503": "Nous subissons une interruption de service. Celle-ci sera prochainement résolue. Nous vous invitons à réessayer dans quelques minutes ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire</a>.",
      "EX401": "Votre session a expiré. Veuillez actualiser la page et réessayer. Si le problème persiste, contactez notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire</a>.",
      "OFXXX": "Nous ne pouvons malheureusement pas traiter votre réservation pour le moment. Veuillez réessayer plus tard. [Code d'erreur : {{errorCode}}]",
      "SEXXX": "Nous ne pouvons malheureusement pas traiter votre réservation pour le moment. Veuillez réessayer plus tard. [Code d'erreur : {{errorCode}}]",
      "SGXXX": "Nous ne pouvons malheureusement pas traiter votre demande pour le moment. Nous vous invitons à réessayer ultérieurement ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "SHXXX": "Nous ne pouvons malheureusement pas récupérer d'autres options de vol pour le moment. Veuillez choisir une autre option ou réessayer plus tard. Vous pouvez également contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "RFXXX": "Nous ne pouvons malheureusement pas traiter votre demande pour le moment. Nous vous invitons à réessayer ultérieurement ou à contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a> [Code d'erreur : {{errorCode}}]",
      "REBOOKING_TIMED_OUT": "La demande de modification de réservation a expiré, mais votre nouvelle réservation est toujours en cours de traitement de notre côté. Si vous ne recevez pas d'e-mail de confirmation dans quelques minutes, veuillez réessayer ultérieurement ou contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a>."
    },
    "SPREEDLY_ERROR_CODE": {
      "ACCOUNT_INACTIVE": "Votre paiement n'a pas pu être traité. Veuillez vous assurer que vous utilisez une carte de test valide ou contactez le service clientèle pour obtenir de l'aide via <a href='{{link}}' target='_blank'>ce formulaire</a>.",
      "BLANK": "Il manque un champ obligatoire. Veuillez remplir toutes les informations de paiement requises et réessayer.",
      "INVALID": "Les informations de paiement que vous avez saisies ne sont pas valides. Veuillez vérifier les champs spécifiés et réessayer.",
      "BLANK_CARD_TYPE": "Le numéro de carte de crédit que vous avez saisi n'est pas valide. Veuillez vérifier le numéro de carte et réessayer.",
      "EXPIRED": "Le mode de paiement que vous avez saisi a expiré. Veuillez utiliser un mode de paiement non expiré et réessayer.",
      "UNKNOWN_REFERRER": "Nous n'avons pas pu vérifier la source de votre demande de paiement. Veuillez réessayer ou contacter le service clientèle pour obtenir de l'aide via <a href='{{link}}' target='_blank'>ce formulaire</a>.",
      "INVALID_REFERRER": "Votre demande de paiement n'a pas pu être traitée en raison d'un problème de sécurité. Veuillez réessayer ou contacter le service clientèle pour obtenir de l'aide via <a href='{{link}}' target='_blank'>ce formulaire</a>.",
      "INVALID_ENVIRONMENT_KEY_PARAMETER": "Une erreur inattendue s'est produite. Veuillez contacter le service clientèle pour obtenir de l'aide via <a href='{{link}}' target='_blank'>ce formulaire</a>."
    },
    "BUTTON": {
      "CONTINUE": "Continuer",
      "BACK": "Retour",
      "CLOSE": "Fermer"
    },
    "PRODUCT_NAME": "Garantie contre les perturbations",
    "PRODUCT_NAME_FLYADEAL": "Assistance premium en cas de perturbations",
    "FLIGHT_INFORMATIONS": {
      "LAYOVER": "Escale de {{time}} – {{airportName}} ({{airportCode}})",
      "BOOKING_REFERENCE": "Référence de la réservation : {{pnrReference}}",
      "STATUS": {
        "CANCELLED": "Annulé",
        "DELAYED": "Retardé",
        "FLOWN": "Parti",
        "BOARDED": "Embarquement effectué",
        "CONFIRMED": "Confirmée"
      },
      "CABIN": {
        "ECONOMY": "Économique",
        "PREMIUM_ECONOMY": "Économie premium",
        "BUSINESS": "Affaires",
        "FIRST": "Premier"
      },
      "NO_STOP": "Direct",
      "STOP": {
        "ZERO": "{{count}} escales : {{destinations}}",
        "ONE": "{{count}} escale : {{destinations}}",
        "TWO": "{{count}} escales : {{destinations}}",
        "FEW": "{{count}} escales : {{destinations}}",
        "MANY": "{{count}} escales : {{destinations}}",
        "OTHER": "{{count}} escales : {{destinations}}"
      },
      "FLIGHT": "Vol",
      "OUTBOUND_FLIGHT": "Vol aller",
      "INBOUND_FLIGHT": "Vol retour",
      "REBOOKED_BY_AIRLINE": "Réservation modifiée par {{partnerName}}",
      "PASSENGER_TYPE": {
        "ADULT": {
          "ZERO": "{{count}} adultes",
          "ONE": "{{count}} adulte",
          "TWO": "{{count}} adultes",
          "FEW": "{{count}} adultes",
          "MANY": "{{count}} adultes",
          "OTHER": "{{count}} adultes"
        },
        "CHILD": {
          "ZERO": "{{count}} enfants",
          "ONE": "{{count}} enfant",
          "TWO": "{{count}} enfants",
          "FEW": "{{count}} enfants",
          "MANY": "{{count}} enfants",
          "OTHER": "{{count}} enfants"
        },
        "SEATED_INFANT": {
          "ZERO": "{{count}} bébés sur un siège",
          "ONE": "{{count}} bébé sur un siège",
          "TWO": "{{count}} bébés sur un siège",
          "FEW": "{{count}} bébés sur un siège",
          "MANY": "{{count}} bébés sur un siège",
          "OTHER": "{{count}} bébés sur un siège"
        },
        "LAP_INFANT": {
          "ZERO": "{{count}} bébés tenus sur les genoux",
          "ONE": "{{count}} bébé tenu sur les genoux",
          "TWO": "{{count}} bébés tenus sur les genoux",
          "FEW": "{{count}} bébés tenus sur les genoux",
          "MANY": "{{count}} bébés tenus sur les genoux",
          "OTHER": "{{count}} bébés tenus sur les genoux"
        }
      }
    },
    "REFUND": {
      "DEFAULT_HEADER": {
        "TITLE": "Obtenir un remboursement",
        "SUBTITLE": "Vous recevrez un remboursement en argent comptant de <b>{{amount}}</b>, soit 100 % du montant couvert de votre réservation. Aucune modification ne sera apportée à votre réservation avec {{partnerName}}. Vous conserverez donc également votre itinéraire de vol actuel.<br /><br />Confirmez vos informations afin que nous puissions traiter votre remboursement !"
      },
      "CONFIRMATION_HEADER": {
        "TITLE": "Demande prise en compte ! Votre remboursement de <b>{{amount}}</b> est en cours de traitement.",
        "SUBTITLE": "Un e-mail de confirmation sera bientôt envoyé à <b>{{email}}</b>. Vous conservez votre réservation de vol initiale. Merci d'avoir utilisé le produit {{productName}} !"
      },
      "FORM_HEADER": {
        "PERSONAL_INFORMATION": "Informations personnelles",
        "HOME_ADDRESS_INFORMATION": "Adresse résidentielle"
      },
      "FORM": {
        "FIRST_NAME": "Prénom",
        "LAST_NAME": "Nom de famille",
        "ADDRESS_LINE_1": "Ligne d'adresse 1",
        "ADDRESS_LINE_2": "Ligne d'adresse 2 (facultatif)",
        "CITY": "Ville",
        "COUNTRY": "Pays",
        "STATE": "État/Province",
        "ZIP": "Code postal"
      }
    },
    "GENDER": {
      "MALE": "Homme",
      "FEMALE": "Femme",
      "UNDISCLOSED": "Non divulgué",
      "UNSPECIFIED": "Non spécifié"
    }
  },
  "HOME": {
    "CONTRACT_ALREADY_REFUNDED": "Votre demande d'annulation a déjà été reçue et votre remboursement est en cours de traitement. Si vous avez besoin d'aide, vous pouvez utiliser <a href='{{link}}' target='_blank'>ce formulaire</a> pour contacter notre équipe du service clientèle.",
    "NO_DISRUPTION": "Nous n'avons trouvé aucun vol retardé ou annulé."
  },
  "NOT_FOUND": {
    "TITLE": "Page introuvable",
    "MESSAGE": "Nous sommes désolés. La page que vous recherchez est introuvable.",
    "GO_HOME": "Aller à la page d'accueil"
  },
  "SERVICE_DISRUPTION_STEP": {
    "TITLE": "Service temporairement indisponible",
    "MESSAGE": "Nous subissons une interruption de service. Celle-ci sera prochainement résolue.",
    "TRY_AGAIN": "Veuillez réessayer dans quelques minutes.",
    "CONTACT_CUSTOMER_SUPPORT": "Contactez le service clientèle"
  },
  "FLIGHT_INFORMATIONS": {
    "NOT_ELIGIBLE": "Nous surveillons votre vol. Revenez ici en cas de retard de plus de {{minMinutesDelay}} minutes ou d'annulation dans les {{maxHoursBeforeDeparture}} heures précédant le départ.",
    "CHOICE_SELECTION": "Que souhaitez-vous faire ?",
    "REBOOK": {
      "TITLE": "Réserver un nouveau vol",
      "DESC": "Vous pouvez choisir de réserver un nouveau vol avec n'importe quelle compagnie aérienne, en sélectionnant des vols partant aujourd'hui ou demain."
    },
    "REFUND": {
      "TITLE": "Obtenir un remboursement et garder mon itinéraire",
      "DESC": "Si les options de modification de la réservation ne vous conviennent pas, obtenez un remboursement de <b>{{amount}}</b> et conservez votre vol affecté par des perturbations."
    }
  },
  "PRODUCT_INFORMATIONS": {
    "PRODUCT_INFO": "Grâce à votre achat du produit {{productName}}, lorsque le vol est annulé ou retardé de plus de {{minMinutesDelay}} minutes dans les {{maxHoursBeforeDeparture}} heures précédant le départ, vous avez droit à une nouvelle réservation de vol ou, si nos options de modification de la réservation ne vous conviennent pas, à un remboursement.",
    "PRODUCT_INFO_HOURS": "Puisque vous avez souscrit à la {{productName}}, vous avez droit à une nouvelle réservation ou, si nos options de nouvelle réservation ne vous satisfont pas, à un remboursement si votre vol est annulé ou retardé de plus de {{minMinutesDelay}} heures dans les {{maxHoursBeforeDeparture}} heures précédant le départ."
  },
  "SLICE_DETAILS_DIALOG": {
    "TITLE": "Vol aller vers {{destination}}"
  },
  "SLICE_INFORMATIONS": {
    "ELIGIBLE_FOR_REBOOKING": "Peut faire l'objet d'une modification de réservation",
    "NOT_ELIGIBLE_FOR_REBOOKING": "Ne peut pas faire l'objet d'une modification de réservation"
  },
  "SEND_VERIFICATION_CODE_STEP": {
    "SEND_VERIFICATION_TITLE": "Est-ce vraiment vous ?",
    "SEND_VERIFICATION_TEXT": "Nous allons envoyer un code à l'adresse e-mail que vous avez utilisée lors de la réservation de votre vol.",
    "BUTTON": {
      "SEND_VERIFICATION_CODE": "Envoyer le code"
    }
  },
  "CHECK_VERIFICATION_CODE_STEP": {
    "CHECK_VERIFICATION_TITLE": "Est-ce vraiment vous ?",
    "CHECK_VERIFICATION_TEXT": "Nous venons d'envoyer un e-mail contenant un code de vérification à l'adresse {{email}}.",
    "BUTTON": {
      "RESEND_VERIFICATION_CODE": "Envoyer un nouveau code"
    }
  },
  "HYPERWALLET_FORM_STEP": {
    "FORM": {
      "MIDDLE_NAME": "Deuxième prénom (facultatif)",
      "DATE_OF_BIRTH": "Date de naissance"
    }
  },
  "HYPERWALLET_REFUND_STEP": {
    "RECEIVE_AMOUNT_TITLE": "Comment souhaitez-vous recevoir votre remboursement ?"
  },
  "SPREEDLY_FORM_STEP": {
    "CARD_INFORMATION": "Informations de la carte",
    "FORM": {
      "FULL_NAME": "Nom complet",
      "CARD_NUMBER": "Numéro de carte",
      "EXPIRATION_MONTH": "Mois d'expiration",
      "EXPIRATION_YEAR": "Année d'expiration",
      "CVV": "Code de sécurité"
    },
    "BUTTON": {
      "REDIRECT_TO_BANK_TRANSFER": "Je n'ai pas de carte de crédit"
    }
  },
  "BANK_TRANSFER_FORM_STEP": {
    "DESC": "Nous émettrons votre remboursement vers votre compte bancaire.",
    "FORM": {
      "BANK_INFORMATION": "Informations du compte bancaire",
      "ACCOUNT_NUMBER": "Numéro de compte bancaire/IBAN",
      "BANK_ID": "Code SWIFT/BIC",
      "ACCOUNT_HOLDER_INFORMATION": "Informations sur le titulaire du compte",
      "VALIDATION": {
        "REQUIRED": "Ce champ est obligatoire",
        "INVALID_IBAN": "Veuillez saisir un IBAN valide",
        "INVALID_BIC": "Veuillez saisir un code SWIFT/BIC valide",
        "formValidationAccountNumberRequired": "Veuillez saisir votre numéro de compte bancaire.",
        "formValidationBankCodeRequired": "Veuillez saisir votre code banque.",
        "formValidationBankCodeLength": "Le code banque doit comporter entre 8 et 11 caractères.",
        "formValidationBankCodeFirstChars": "Le code banque doit commencer par 4 lettres.",
        "formValidationBankCodeCountryUnsupported": "Le pays de ce code banque n'est pas pris en charge pour les virements internationaux.",
        "formValidationBankCodeCountryInvalid": "Le code pays de votre code banque n'est pas valide.",
        "formValidationBankCodeLocationInvalid": "Le code localisation de votre code banque n'est pas valide.",
        "formValidationBankCodeBranchInvalid": "Le code agence de votre code banque n'est pas valide.",
        "formValidationIbanCharsInvalid": "Votre numéro de compte bancaire contient des caractères non valides. Veuillez utiliser uniquement des lettres et des chiffres.",
        "formValidationIbanCountryInvalid": "Votre numéro de compte bancaire doit commencer par un code pays valide.",
        "formValidationIbanCountryUnsupported": "Le pays de ce numéro de compte bancaire n'est pas pris en charge pour les virements internationaux.",
        "formValidationIbanLengthInvalid": "La longueur de votre numéro de compte bancaire n'est pas valide pour ce pays.",
        "formValidationIbanChecksumInvalid": "Votre numéro de compte bancaire est invalide. Veuillez vérifier et réessayer.",
        "formValidationIbanBicCountryMismatch": "Le pays de votre numéro de compte bancaire ne correspond pas au pays de votre code banque."
      }
    }
  },
  "PAYOUT_ERROR_STEP": {
    "TITLE": "{{productName}} : nous n'avons pas pu traiter votre demande",
    "SUBTITLE": "Un problème est survenu lors de votre remboursement. Veuillez nous excuser pour la gêne occasionnée. Veuillez cliquer sur <b>Continuer</b> pour consulter nos options relatives au traitement de votre remboursement. Si vous rencontrez des difficultés, veuillez contacter notre service clientèle en utilisant <a href='{{link}}' target='_blank'>ce formulaire.</a>",
    "NO_PAYOUT_OPTIONS": "Veuillez utiliser <a href='{{link}}' target='_blank'>ce formulaire</a> pour contacter notre service clientèle."
  },
  "REBOOKING_CONFIRMATION_STEP": {
    "TITLE": "Installez-vous et détendez-vous ! Votre nouvelle réservation est confirmée.",
    "SUBTITLE": "Un e-mail de confirmation sera envoyé sous peu à {{email}}. Merci d'avoir utilisé le produit {{productName}} !",
    "YOUR_NEW_FLIGHT": "Votre nouveau vol",
    "ROUND_TRIP_WARNING": "Nous vous conseillons vivement de confirmer directement auprès de Frontier Airlines que les vols restants de votre réservation, y compris les vols de retour, ne seront pas annulés si vous refusez ou ignorez les options de modification de réservation proposées par Frontier Airlines."
  },
  "REBOOKING_FORM_STEP": {
    "TITLE": "Informations sur le passager",
    "SUBTITLE": "Confirmez vos informations avant de réserver votre nouveau vol.",
    "LOADING_REBOOK": "Modification de réservation en cours…",
    "PASSENGER": "Passager {{index}}",
    "BUTTON": {
      "SUBMIT": "Confirmer et réserver à nouveau"
    },
    "TRAVEL_DOCUMENT": "Document de voyage",
    "FORM": {
      "FIRST_NAME": "Prénom",
      "LAST_NAME": "Nom de famille",
      "GENDER": "Sexe",
      "DOCUMENT_TYPE": "Type de document",
      "PASSPORT_NUMBER": "Numéro de passeport",
      "COUNTRY_ISSUANCE": "Pays d'émission",
      "NATIONALITY": "Nationalité",
      "ISSUANCE_DATE": "Date d'émission",
      "EXPIRATION_DATE": "Date d'expiration",
      "DATE_OF_BIRTH": "Date de naissance",
      "NATIONAL_ID_NUMBER": "Numéro de la carte nationale d'identité"
    },
    "DOCUMENT_TYPES": {
      "passport": "Passeport",
      "national_id": "Identifiant national"
    }
  },
  "REBOOKING_REVIEW_STEP": {
    "TITLE": "Modifiez votre vol",
    "SUBTITLE": "Vous pouvez choisir de réserver gratuitement un nouveau vol (jusqu'à {{serviceCap}} par passager), en choisissant parmi les vols du jour même ou du lendemain. Si vous choisissez un nouveau vol, votre vol {{partnerName}} initial sera annulé, mais vous conserverez vos vols retour, le cas échéant.",
    "LOADING_REBOOK": "Modification de réservation en cours…",
    "CHOICE_SUMMARY": "Voici un récapitulatif de votre sélection",
    "DIFFERENT_AIRPORT": "Veuillez vérifier votre itinéraire, car vous avez sélectionné un itinéraire de vol au départ ou à destination d'un aéroport différent de votre vol initial."
  },
  "REBOOKING_SEARCH_ALTERNATIVES_STEP": {
    "TITLE": "Modifiez votre vol",
    "SUBTITLE": "Vous pouvez choisir de réserver gratuitement un nouveau vol (jusqu'à {{serviceCap}} par passager), en choisissant parmi les vols du jour même ou du lendemain. Si vous choisissez un nouveau vol, votre vol {{partnerName}} initial sera annulé, mais vous conserverez vos vols retour, le cas échéant.",
    "LOADING_REBOOK": "Modification de réservation en cours…",
    "LOADING_ALTERNATIVES": "Veuillez patienter pendant que nous chargeons vos options de modification de réservation",
    "ONE_MORE_ALTERNATIVE": "{{nbAlternative}} autre option",
    "MORE_ALTERNATIVES": "{{nbAlternative}} autres options",
    "NO_ALTERNATIVE": "Nous sommes désolés, il n'y a pas d'options de vol disponibles partant à cette date pour le moment. Vous pouvez sélectionner l'une des options suivantes : ",
    "BAGS_TITLE": "Avez-vous des bagages enregistrés ?",
    "BUTTON": {
      "YES": "Oui",
      "NO": "Non",
      "GO_TO_REFUND_FLOW": "Choisir notre option de remboursement",
      "SEARCH_FOR_OTHER_DAY": "Rechercher des vols la veille ou plus tard"
    },
    "OUTBOUND": "Aller vers {{destination}}",
    "NO_STOP": "Direct",
    "STOP": {
      "ZERO": "{{count}} escales",
      "ONE": "{{count}} escale",
      "TWO": "{{count}} escales",
      "FEW": "{{count}} escales",
      "MANY": "{{count}} escales",
      "OTHER": "{{count}} escales"
    },
    "SEE_OTHER_AIRLINES": "Afficher d'autres compagnies aériennes"
  },
  "WARNING_BAGS_DIALOG": {
    "TITLE": "Avis important sur les bagages enregistrés",
    "DESC": "Vos bagages sont déjà enregistrés auprès de la compagnie aérienne pour le vol affecté par des perturbations. Ils doivent donc être récupérés et enregistrés sur votre nouveau vol. Pour ce faire, veuillez vous rendre au comptoir d'enregistrement de la compagnie aérienne à l'aéroport.<br /><br />Nous ne pouvons pas garantir que vos bagages pourront être récupérés à temps pour être enregistrés sur votre nouveau vol.",
    "DESC_FLYADEAL": "Vos bagages sont déjà enregistrés auprès de la compagnie aérienne pour le vol affecté par des perturbations. Ils doivent donc être récupérés et enregistrés sur votre nouveau vol. Pour ce faire, veuillez vous adresser au service client de la compagnie aérienne ou vous rendre dans la zone de retrait des bagages de l'aéroport.<br /><br />Le retrait et l'enregistrement dans les délais de vos bagages pour le nouveau vol sont sous votre responsabilité.",
    "BUTTON": {
      "REFUND": "Conserver le vol et obtenir un remboursement",
      "REBOOK": "Modifier le vol et gérer mes bagages"
    }
  },
  "ALTERNATIVE_DETAILS_DIALOG": {
    "TITLE": "Vol aller vers {{destination}}",
    "BUTTON": {
      "SUBMIT": "Sélectionner ce vol"
    }
  }
}
